import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConteudoComponent } from './layout/conteudo/conteudo.component';
import { PaginaComponent } from './layout/pagina/pagina.component';
import { NotFoundComponent } from './layout/not-found/not-found.component';
import { NoticiaDetalheComponent } from './layout/noticia-detalhe/noticia-detalhe.component';
import { VideosDetalheComponent } from './layout/video-detalhe/video-detalhe.component';
import { PesquisaComponent } from './layout/pesquisa/pesquisa.component';

export const routes: Routes = [
  { path: '', component: ConteudoComponent },
  { path: 'pagina/:id', component: PaginaComponent },
  { path: 'noticia', component: NoticiaDetalheComponent },
  { path: 'noticia/:id', component: NoticiaDetalheComponent },
  { path: 'video', component: VideosDetalheComponent },
  { path: 'video/:id', component: VideosDetalheComponent },
  { path: 'pesquisa', component: PesquisaComponent },
  { path: 'pesquisa/:texto', component: PesquisaComponent },
  {path: '**', component: NotFoundComponent}
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {useHash: true}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
